import { compose } from "recompose";
import withProductsByOptions from "./withProductsByOptions";
import withSelectedOptions from "./withSelectedOptions";
import withSelectedCustomOptions from "./withSelectedCustomOptions";
import withSelectedBundleOptions from "./withSelectedBundleOptions";
import withSelectedGroupedItems from "./withSelectedGroupedItems";

export default () =>
  compose(
    withProductsByOptions(),
    withSelectedOptions(),
    withSelectedCustomOptions(),
    withSelectedBundleOptions(),
    withSelectedGroupedItems()
  );
